import React from 'react';
import { Link } from 'react-router-dom';
import { GraduationCap, BookOpen, Award, Users, ArrowRight, CreditCard } from 'lucide-react';
import './Services.css';
import './Training.css';

function Training() {
  return (
    <>
      <section className="page-hero">
        <div className="page-hero__bg">
          <img src="/images/school.jpg" alt="Groomer training academy" />
          <div className="page-hero__overlay" />
        </div>
        <div className="page-hero__content container">
          <span className="section-label" style={{ color: 'var(--color-accent-light)' }}>Academy</span>
          <h1 className="page-hero__title">City &amp; Guilds Qualifications &amp; Professional Salon Training</h1>
          <p className="page-hero__subtitle">
            Structured, career-focused dog grooming training delivered within a real working salon environment.
          </p>
        </div>
      </section>

      <section className="services-intro section">
        <div className="container">
          <div className="services-intro__content">
            <p>
              Tails &amp; Tweed Academy provides structured, career-focused dog grooming training
              delivered within a real working salon environment.
            </p>
            <p>
              Built on over 25 years of hands-on industry experience, our training combines
              technical precision, welfare-led handling, and honest preparation for life in the
              grooming industry.
            </p>
            <p><strong>We train future professionals.</strong></p>
          </div>
        </div>
      </section>

      <section className="training section" style={{ paddingTop: 0 }}>
        <div className="container">
          {/* Why Train With Us */}
          <div className="training__why">
            <h3 className="training__heading">Why Train With Tails &amp; Tweed?</h3>
            <div className="training__why-grid">
              <ul className="training__why-list">
                <li>City &amp; Guilds recognised qualifications</li>
                <li>Small group, hands-on learning</li>
                <li>Real salon experience</li>
                <li>High standards from day one</li>
                <li>Honest insight into the industry</li>
                <li>Ongoing mentorship and support</li>
              </ul>
              <p className="training__why-note">
                Our academy is designed for individuals who are serious about building a career
                &mdash; whether employed in a salon or self-employed.
              </p>
            </div>
          </div>

          {/* Training Pathways */}
          <div className="training__courses">
            <h3 className="training__heading">Your Training Pathways</h3>
            <p className="training__intro-text">
              We offer clear, structured routes depending on your experience level and career goals.
            </p>
            <div className="courses-grid">
              <div className="course-card">
                <div className="course-card__icon">
                  <GraduationCap size={28} />
                </div>
                <div className="course-card__badge">Level 2</div>
                <h4 className="course-card__title">Dog Grooming Assistant</h4>
                <p className="course-card__duration">10 days (Extended 15 day course also available)</p>
                <p className="course-card__text">
                  Designed for beginners entering the industry. Learn essential salon skills, safe
                  handling, bathing, drying, and preparation techniques that form the foundation of
                  professional grooming.
                </p>
                <p className="course-card__ideal">Ideal for career starters or those supporting stylists in a salon.</p>
              </div>

              <div className="course-card course-card--featured">
                <div className="course-card__icon">
                  <Award size={28} />
                </div>
                <div className="course-card__badge">Level 3</div>
                <h4 className="course-card__title">Professional Dog Stylist</h4>
                <p className="course-card__duration">20 days (Extended 30 option also available)</p>
                <p className="course-card__text">
                  Advanced training focused on styling, scissoring, clipping techniques, coat
                  knowledge and client consultation. This qualification prepares you to work
                  independently as a professional groomer.
                </p>
                <p className="course-card__ideal">Ideal for those progressing from Level 2 or with relevant experience.</p>
              </div>

              <div className="course-card">
                <div className="course-card__icon">
                  <BookOpen size={28} />
                </div>
                <div className="course-card__badge">Combined</div>
                <h4 className="course-card__title">Combined Level 2 &amp; 3</h4>
                <p className="course-card__duration">30 days (Extended 40 day option also available)</p>
                <p className="course-card__text">
                  Our most comprehensive pathway. A structured progression from foundation skills
                  through to advanced styling, designed for those fully committed to becoming
                  qualified professional groomers.
                </p>
                <p className="course-card__ideal">Ideal for career changers or those wanting complete training from start to finish.</p>
              </div>

              <div className="course-card">
                <div className="course-card__icon">
                  <Users size={28} />
                </div>
                <div className="course-card__badge">Non-Exam</div>
                <h4 className="course-card__title">Professional Salon Courses</h4>
                <p className="course-card__duration">Non-Exam Route</p>
                <p className="course-card__text">
                  For those who do not wish to sit City &amp; Guilds examinations but want
                  practical, structured salon training. These courses focus on hands-on skills
                  without formal assessment.
                </p>
              </div>
            </div>
          </div>

          {/* Finance */}
          <div className="training__finance">
            <div className="training__finance-icon">
              <CreditCard size={28} />
            </div>
            <div>
              <h3 className="training__heading" style={{ marginBottom: 12 }}>Finance Options Available</h3>
              <p>
                We understand that professional training is an investment. Finance options are
                available through Ideal4Finance, allowing eligible students to spread the cost
                of their course through structured payment plans.
              </p>
            </div>
          </div>
        </div>
      </section>

      <section className="page-cta">
        <div className="container">
          <div className="page-cta__inner">
            <div className="page-cta__content">
              <h2>Start Your Grooming Career</h2>
              <p>Get in touch to learn more about our courses and enrolment.</p>
            </div>
            <div className="page-cta__actions">
              <Link to="/contact" className="btn btn-accent">
                Enquire Now <ArrowRight size={16} />
              </Link>
              <a href="tel:07904813567" className="btn btn-outline" style={{ borderColor: 'var(--color-white)', color: 'var(--color-white)' }}>
                Call Us
              </a>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}

export default Training;
